var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"preview"},[(_vm.loading.email === 'PENDING')?_c('mks-loading'):_c('div',[_c('iframe',{staticClass:"iframe",attrs:{"srcdoc":_vm.email.content}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }